// Compteur fenêtré de retours redirect MSAL sans compte (AADSTS50196 / boucle SSO pourrie).
// Voir docs/standards/AUTH_ROBUSTNESS.md

export const GS_AUTH_LOOP_KEY = 'gs_auth_loop';
export const AUTH_LOOP_THRESHOLD = 3;
export const AUTH_LOOP_WINDOW_MS = 60_000;

export interface AuthLoopState {
  count: number;
  firstAt: number;
}

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function readAuthLoopState(storage: StorageLike = sessionStorage): AuthLoopState | null {
  try {
    const raw = storage.getItem(GS_AUTH_LOOP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthLoopState;
    if (typeof parsed.count !== 'number' || typeof parsed.firstAt !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeAuthLoopState(state: AuthLoopState, storage: StorageLike = sessionStorage): void {
  try {
    storage.setItem(GS_AUTH_LOOP_KEY, JSON.stringify(state));
  } catch {
    void 0;
  }
}

export function resetAuthLoopCounter(storage: StorageLike = sessionStorage): void {
  try {
    storage.removeItem(GS_AUTH_LOOP_KEY);
  } catch {
    void 0;
  }
}

/**
 * Incrémente le compteur (fenêtre glissante 60 s). Retourne true si seuil 3 atteint.
 */
export function recordFailedRedirectReturn(
  now = Date.now(),
  storage: StorageLike = sessionStorage,
): boolean {
  const existing = readAuthLoopState(storage);
  const state: AuthLoopState =
    !existing || now - existing.firstAt > AUTH_LOOP_WINDOW_MS
      ? { count: 1, firstAt: now }
      : { count: existing.count + 1, firstAt: existing.firstAt };
  writeAuthLoopState(state, storage);
  return state.count >= AUTH_LOOP_THRESHOLD;
}

export function isAuthLoopDetected(storage: StorageLike = sessionStorage, now = Date.now()): boolean {
  const state = readAuthLoopState(storage);
  if (!state) return false;
  if (now - state.firstAt > AUTH_LOOP_WINDOW_MS) return false;
  return state.count >= AUTH_LOOP_THRESHOLD;
}

/** Détecte un retour de redirect Entra (hash OAuth) avant traitement MSAL. */
export function hadOAuthRedirectHash(location: Pick<Location, 'hash'> = window.location): boolean {
  const hash = location.hash ?? '';
  return /(?:^|[&#])(code|error|state)=/.test(hash);
}
